// W55 — the pure helpers behind Mira's saved conversations, kept out of the panel so they are unit
// testable without rendering it.
//
// A conversation's title is HER first message, cut short. It is never composed from an id, and a
// title that looks like a filename is treated as no title (CLAUDE.md: a filename can arrive through a
// title field) — the row then shows its date alone rather than a raw identifier.

export const TITLE_MAX = 60;

const FILENAME_RE = /^[^\s/\\]+\.[A-Za-z0-9]{2,5}$/;

export function titleFromMessage(text) {
  const clean = String(text || "").replace(/\s+/g, " ").trim();
  if (clean.length <= TITLE_MAX) return clean;
  const cut = clean.slice(0, TITLE_MAX);
  const space = cut.lastIndexOf(" ");
  return `${(space > TITLE_MAX / 2 ? cut.slice(0, space) : cut).trim()}…`;
}

export function displayTitle(row) {
  const title = String(row?.title || "").trim();
  if (!title || FILENAME_RE.test(title)) return "";
  return title;
}

// Stored turns -> the panel's thread. Mira's turns are stored as "assistant" by the server and as
// "mira" when the panel saved an offer seed; anything else (or an empty turn) is not shown.
export function threadFromTurns(turns, newId) {
  const out = [];
  for (const turn of turns || []) {
    const text = String(turn?.text || "").trim();
    if (!text) continue;
    if (turn.role === "user") out.push({ role: "user", text });
    else if (turn.role === "assistant" || turn.role === "mira") out.push({ role: "mira", text, id: newId() });
  }
  return out;
}

// Newest first, by when she last spoke in it. The server already orders the list this way; the
// panel does not trust a transport to keep an order it did not state.
export function newestFirst(rows) {
  return [...(rows || [])].sort((a, b) =>
    String(b?.updated_at || b?.created_at || "").localeCompare(String(a?.updated_at || a?.created_at || ""))
  );
}
